import * as React from 'react';

import { Box } from '@leagueplatform/genesis-core';
import { useScrollTopOnLocationChange } from '@leagueplatform/web-common';
import {
  APP_NAV_DEFAULT_HEIGHT,
  ErrorBoundary,
  LoadingSpinner,
} from '@highmark-web/highmark-common';
import { AppNavBarComponent } from 'components/nav/nav.component';
import { Outlet } from 'react-router-dom';

const MAIN_CONTENT_MIN_HEIGHT = `calc(100vh - ${APP_NAV_DEFAULT_HEIGHT}px)`;

export const PrivateBasePage: React.FC = () => {
  useScrollTopOnLocationChange();

  return (
    <>
      <AppNavBarComponent />
      <Box
        as="main"
        id="main-content"
        css={{
          position: 'relative',
          flex: '1',
          overflowX: 'hidden',
          // This is so any page will take up the whole screen regardless of content
          minHeight: MAIN_CONTENT_MIN_HEIGHT,
          paddingBottom: '$twoAndHalf',
        }}
      >
        <ErrorBoundary
          contextLocation="BasePage ErrorBoundary"
          styleErrorProps={{ minHeight: MAIN_CONTENT_MIN_HEIGHT }}
        >
          <React.Suspense fallback={<LoadingSpinner />}>
            <Outlet />
          </React.Suspense>
        </ErrorBoundary>
      </Box>
    </>
  );
};
